import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';

@Component({
  selector: 'app-tags',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    CommonModule,
    PermissionDirective,
    NoDataComponent,
    ContentLoaderComponent,
  ],
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss',
})
export class TagsComponent {
  tagsArray: { id: number; tagName: string; category?: string }[] = [];
  storyTags: { id: number; tagName: string; category?: string }[] = [];
  coloringImageTags: { id: number; tagName: string; category?: string }[] = [];
  posterTags: { id: number; tagName: string; category?: string }[] = [];
  public languages: any[] = [];
  public langCode: String = '';
  noData = false;
  loading = false;

  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  readonly dialog = inject(MatDialog);
  constructor(
    private router: Router,
    private tagsService: TagsLanguageService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getAllTags(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllTags(this.langCode, searchTerm);
      });
  }

  createNewtag() {
    this.router.navigate(['tags/new']);
  }

  onEditTag(id: any) {
    this.router.navigate([`tags/edit/${id}`]);
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  onDeleteTag(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteTag(id);
      }
    });
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onLanguageSelect(event: any) {
    this.langCode = event.value;
    this.getAllTags(this.langCode);
  }

  deleteTag(id: any): void {
    this.tagsService.removeTag(id).subscribe({
      next: (res) => {
        this.toastr.success(res.message);
        this.getAllTags(this.langCode);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getAllTags(lang: any, search = ''): void {
    this.loading = true;
    this.tagsService.getAllTagsWithFilter(lang, search).subscribe({
      next: (res) => {
        const tagList = res?.data || [];
        if (res.data.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        this.tagsArray = tagList
          .map((tag: any) => {
            const translations = tag.tagTranslation || [];
            if (translations.length === 0) {
              return null;
            }
            const lang1Translation = translations.find(
              (t: any) => t.langId === 1
            );
            return {
              id: tag.id,
              tagName: lang1Translation
                ? lang1Translation.tagName
                : translations[0].tagName,
              category: tag.type || 'story',
            };
          })
          .filter((tag: any) => tag !== null);
        this.storyTags = this.tagsArray.filter((t) => t.category === 'story');
        this.coloringImageTags = this.tagsArray.filter((t) => t.category === 'coloring');
        this.posterTags = this.tagsArray.filter((t) => t.category === 'poster');
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      },
    });
  }
}
